<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="formRules" label-width="120px">
      <a-form-model-item label="运输单号" prop="orderNo">
        <a-input auto-complete="off" v-model="form.data.orderNo" placeholder="请输入运输单号"/>
      </a-form-model-item>
      <a-form-model-item label="WMS No.">
        <a-input auto-complete="off" v-model="form.data.wmsNo" placeholder="请输入WMS No."/>
      </a-form-model-item>
<!--      <a-form-model-item label="运输方式" prop="orderStatus" >-->
<!--        <a-select v-model="form.data.transportType" placeholder=""-->
<!--                   style="width: 100%">-->
<!--          <a-select-option-->
<!--            v-for="item in orderTransportTypeList"-->
<!--            :key="item.code"-->
<!--            :label="item.name"-->
<!--            :value="item.code">-->
<!--            {{ item.name }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="GPS No" prop="gpsNo" v-if="form.data.transpinortType ==='GPS' ">-->
<!--        <a-input auto-complete="off" v-model="form.data.gpsNo" placeholder="请输入GPS No"/>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="快递名称" prop="expressCode">-->
<!--        <a-select v-model="form.data.expressCode" placeholder="" style="width: 100%" clearable>-->
<!--          <a-select-option-->
<!--            v-for="item in expressList"-->
<!--            :key="item.name"-->
<!--            :label="item.name"-->
<!--            :value="item.name">-->
<!--            {{ item.name }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="收货城市" prop="receiveCity">-->
<!--        <a-input auto-complete="off" v-model="form.data.receiveCity" placeholder="请输入收货城市"/>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="手机尾号" prop="telTailNumber">
        <a-input auto-complete="off" v-model="form.data.telTailNumber" placeholder="请输入手机尾号"/>
      </a-form-model-item>
      <a-form-model-item label="收货状态" prop="orderStatus" >
        <a-select v-model="form.data.orderStatus" placeholder="" :clearable="true" style="width: 100%" disabled>
          <a-select-option
            v-for="item in orderStatusList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="收货时间" prop="recieveTime" v-if="form.data.orderStatus ==='CLOSED' ">
        <a-date-picker
          v-model="form.data.recieveTime"
          showTime="true"
          value-format="YYYY-MM-DD HH:mm:ss"
          placeholder="选择日期">
        </a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="客户名称" prop="customerName">
        <a-input auto-complete="off" v-model="form.data.customerName" placeholder="请输入客户名称"/>
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="receiveAddress">
        <a-input auto-complete="off" v-model="form.data.receiveAddress" placeholder="请输入计费重量"/>
      </a-form-model-item>
<!--      <div style="text-align: right">-->
<!--        <a-button-->
<!--          type="primary"-->
<!--          v-if="bizOrderId" @click="onUpdate('ruleForm')" :disabled="form.disabled">更新-->
<!--          <i class="el-icon-loading el-icon&#45;&#45;right" v-if="form.disabled"/>-->
<!--        </a-button>-->
<!--        <a-button @click="onCancel">取消</a-button>-->
<!--      </div>-->
    </a-form-model>

    <div class="page-dialog">

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { findOrder, updateOrders } from '../../../api/order';
import {
  getExpressList,
} from '../../../api/express';

async function getBizOrder() {
  const result = await findOrder(this.bizOrderId);
  if (result.code === 1200) {
    this.form.data.receiveCity = result.data.orders.receiveCity;
    this.form.data.id = result.data.orders.id;
    this.form.data.customerName = result.data.orders.customerName;
    this.form.data.receiveAddress = result.data.orders.receiveAddress;
    this.form.data.orderNo = result.data.orders.orderNo;
    this.form.data.gpsNo = result.data.orders.gpsNo;
    this.form.data.expressCode = result.data.orders.expressCode;
    this.form.data.wmsNo = result.data.orders.wmsNo;
    this.form.data.orderStatus = result.data.orders.orderStatus;
    this.form.data.telTailNumber = result.data.orders.telTailNumber;
    if (result.data.orders.receiveAt) {
      this.form.data.recieveTime = new Date(result.data.orders.receiveAt);// result.data.orders.receiveAt;
    }
    this.form.data.img = result.data.orders.img;
    this.form.data.transportType = result.data.orders.transportType;
  }
}


function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await updateOrders({
        ...this.form.data,
        recieveTime: moment(this.form.data.recieveTime).format('YYYY-MM-DD HH:mm:ss'),
      });
      if (result.code === 1200) {
        // if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.getList();
          // this.$refs.form.resetFields();
          // this.onSubmitHandler();
        // }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    // this.onCancelHandler();
  }
  this.$refs.form.resetFields();
}


export default {
  name: 'BizOrderEdit',
  props: {
    bizOrderId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
    getList: Function
  },
  watch: {
    bizOrderId() {
      if (this.bizOrderId) {
        this.getBizOrder();
      }
    },
  },
  methods: {
    onUpdate,
    onCancel,
    getBizOrder,
    save(){
      this.onUpdate();
    }
  },
  data() {
    const validateExpress = (rule, value, callback) => {
      // if (value && this.form.data.gpsNo) {
      //     return callback(new Error('gps号和快递名称不能一起填！'));
      // } else
      if (!value && this.form.data.gpsNo === '') {
        return callback(new Error('gps号和快递名称两者必须填一个！'));
      }
      return callback();
    };
    return {

      expressList: [],
      orderStatusList: [
        { code: 'CREATE', name: '已创建' },
        { code: 'DELIVERY', name: '已出库' },
        { code: 'COLLECT', name: '已揽收' },
        { code: 'SEND', name: '运输中' },
        { code: 'CLOSED', name: '已签收' },
      ],
      orderTransportTypeList: [
        { code: 'GPS', name: 'GPS运输' },
        { code: 'THIRDPART', name: '快递鸟' },
      ],
      form: {
        data: {
          id: '',
          receiveCity: '',
          customerName: '',
          receiveAddress: '',
          orderNo: '',
          gpsNo: '',
          expressCode: '',
          wmsNo: '',
          recieveTime: '',
          orderStatus: '',
          img: '',
          transportType: '',
          telTailNumber: '',
        },
        title: '',
      },
      formRules: {
        // orderNo: [
        //     {required: true, message: '请输入订单号', trigger: 'blur'},
        // ],
        // expressCode: [
        //     {required: false, validator: validateExpress, trigger: 'change'},
        // ],
      },
    };
  },
  async created() {
    if (this.bizOrderId) {
      this.getBizOrder();
    }
    const expressLists = await getExpressList();
    this.expressList = expressLists.data.express;
  },
};
</script>
